import { Grid, Filter, Page, Sort, RecordClickEventArgs } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ModalHelper } from '../../Helpers/ModalHelper';

export class EnquiryOverviewManager {

    constructor(private containerElement: JQuery) { }
    
    private viewWorkbookModalHelper : ModalHelper;

    private workbookGrid : Grid;
    

    public initialize() {
        var self = this;

        this.viewWorkbookModalHelper = new ModalHelper();
        this.viewWorkbookModalHelper.createModal("view-workbook-popup", true);

        Grid.Inject(Filter, Page, Sort);

        self.initializeEnquiriesTable();
    }

    private initializeEnquiriesTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var uploadContainer = self.containerElement.find('#upload-and-workbooks-container');
        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#Grid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        let data: DataManager = new DataManager({
            url: '/api/company/excel/enquiries',
            adaptor: new WebApiAdaptor
        });

        self.workbookGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                columns: [
                    { field: 'UploadDateTimeString', headerText: 'Upload datetime', width: 125},
                    { field: 'UploadedBy', headerText: 'Upload by', width: 150 },
                    { field: 'WorkbookName', headerText: 'Workbook', autoFit: true, width: 350},
                    { field: 'FormatString', headerText: 'Format type', width: 100},
                    { field: 'CustomerName', headerText: 'Customer',  width: 250},
                    { field: 'VesselName', headerText: 'Vessel', width: 250},
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                allowResizing: false,
                pageSettings: { pageSize: 20 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')

                    loadingContainer.addClass('d-none');
                    uploadContainer.removeClass('d-none');
                },
                recordClick: (args: RecordClickEventArgs) => {
                    // if (args.target != undefined && args.rowData != undefined) {
                    //     var parsedTarget = $(args.target); 
                    //     var enquiryId = args.rowData["Id"];

                        
                    //     location.href = `/Company/Excel/Enquiry/${enquiryId}`;
                    // }
                }
            });
        self.workbookGrid.appendTo('#Grid');
    }

}